import { render, staticRenderFns } from "./AddressInfoItem.vue?vue&type=template&id=0ebf8a92&scoped=true&"
import script from "./AddressInfoItem.vue?vue&type=script&lang=js&"
export * from "./AddressInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfoItem.vue?vue&type=style&index=0&id=0ebf8a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf8a92",
  null
  
)

export default component.exports